import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react'

import { envStorage } from 'core/stores/env'

const STORAGE_KEY = 'betaPages'

type BetaPagesContextType = {
  betaPages: boolean
  setBetaPages: (value: boolean) => void
}

const BetaPagesContext = createContext<BetaPagesContextType>({
  betaPages: false,
  setBetaPages: () => {},
})

const BetaPagesProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [betaPages, setBetaPages] = useState<boolean>(
    () => envStorage.get(STORAGE_KEY) === true,
  )

  const value = useMemo(
    () => ({
      betaPages,
      setBetaPages: (next: boolean) => {
        setBetaPages(next)
        envStorage.set(STORAGE_KEY, next)
      },
    }),
    [betaPages],
  )

  return (
    <BetaPagesContext.Provider value={value}>
      {children}
    </BetaPagesContext.Provider>
  )
}

const useBetaPages = () => useContext(BetaPagesContext)

export { BetaPagesProvider, useBetaPages }
